import ProductMapModal from './ProductMapModal'
import UpdateAmountModal from './UpdateAmountModal'

export { ProductMapModal, UpdateAmountModal }



// WEBPACK FOOTER //
// ./src/components/ProductModal/index.js